import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import ChatbotAssistantV2 from '../../../components/Chatbot/ChatbotAssistant';
import { chatbotDefaultConfig } from '../../../common/constants';
import { IDIChannelMapping, isAsyncUser } from '../../../../js/lib/asyncMessageHelper';
import { getC3MarketChannelEligibility, getModalChannelType } from '../../../../js/lib/globalHelper';
import { chatBotClickedAction } from '../../../../js/contactUs/actions/action-chat-bot';
import { requestLoggedOutChatValidation } from '../../../../js/lib/loggedOutChatHelper';
import { loadModalContainer } from '../../../../js/contactUs/actions/action-login-modal';
import { FPTI_DATA } from '../../../common/propTypes';
import {
  CHAT_BOT,
  CONTACT_TOPIC_TREE_INTENTS,
  OCP_CONTEXT_RESPONSE,
  POST_CHAT_BOT_ELIGIBILITY,
} from '../../../common/storeConstants';
import { isLoggedIn } from '../../../helpers/twHelper';

const ChatbotPanel = function (props) {
  const { setContextIntents: chatPillOcpParams } = useSelector((state) => state[OCP_CONTEXT_RESPONSE]);
  const { chatBotAsync, chatBotDisplay: showChatBot } = useSelector((state) => state[POST_CHAT_BOT_ELIGIBILITY]);
  const { chatBotShow: chatBotShowAfterSpinner } = useSelector((state) => state[CHAT_BOT]);
  const { selectedFinalIntent } = useSelector((state) => state[CONTACT_TOPIC_TREE_INTENTS]);

  const [link, setLink] = useState(chatbotDefaultConfig.LINK);
  const [chatBotTopicRefId, setChatBotTopicRefId] = useState(chatbotDefaultConfig.chatBotTopicRefId);
  const [chatPillOcpParamsValue, setChatPillOcpParamsValue] = useState();
  const [chatBotDisplay, setChatBotDisplay] = useState(false);

  const { FPTIData } = props;
  const { ref_id: topicRefId, topic_name: topicName } = { ...selectedFinalIntent };

  const dispatch = useDispatch();

  // is Chatbot Async user
  const isChatBotAsyncUser = isAsyncUser(chatBotAsync);

  // display chat bot
  useEffect(() => {
    const display = showChatBot && chatBotShowAfterSpinner && getC3MarketChannelEligibility(IDIChannelMapping.CHAT_BOT);
    setChatBotDisplay((prevDisplay) => (prevDisplay !== display ? display : prevDisplay));
  }, [showChatBot, chatBotShowAfterSpinner]);

  // manage intent Ref Id, link, and chatPillOcpParams
  useEffect(() => {
    if (topicRefId) {
      const finalIntentTopicRefId = `${topicRefId}|finalIntent`;
      setChatBotTopicRefId(finalIntentTopicRefId);
      setLink(`${link}|final|${finalIntentTopicRefId}`);
      if (chatPillOcpParams) setChatPillOcpParamsValue(chatPillOcpParams);
    }
  }, [topicRefId, chatPillOcpParams]);

  const chatBotClicked = () => {
    if (isLoggedIn()) return null;

    // Logged out
    // Open up the login modal
    dispatch(chatBotClickedAction());
    if (topicRefId) dispatch(requestLoggedOutChatValidation(topicRefId));
    return dispatch(loadModalContainer(getModalChannelType(isChatBotAsyncUser)));
  };

  return (
    <ChatbotAssistantV2
      link={link}
      id="chatBot"
      display={chatBotDisplay}
      topicRefId={chatBotTopicRefId}
      topicName={topicName}
      chatPillOcpParams={chatPillOcpParamsValue}
      chatBotClicked={chatBotClicked}
      isChatBotAsyncUser={isChatBotAsyncUser}
      FPTIData={FPTIData}
    />
  );
};

ChatbotPanel.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
};

export default ChatbotPanel;
